import { NgModule } from '@angular/core';
import { OnWindowsResizeDirective } from './on-windows-resize.directive';
import { RunScriptsDirective } from './unsafe-html/run-scripts.directive';
import { SafeHtmlPipe } from './unsafe-html/unsafe-html-pipe.pipe';
import { UrlifyDirective } from './content-urlify';

@NgModule({
  imports: [],
  declarations: [
    OnWindowsResizeDirective,
    RunScriptsDirective,
    SafeHtmlPipe,
    UrlifyDirective
  ],
  exports: [
    OnWindowsResizeDirective,
    RunScriptsDirective,
    SafeHtmlPipe,
    UrlifyDirective
  ]
})

export class UtilsModule {
}
